import React, { useContext } from "react";
import "./YouTooText.module.scss";
import { HomeContext } from "screens/Home/Home";

export default function YouTooText() {
  const { setActiveFilters } = useContext(HomeContext);
  return (
    <div styleName="YouTooText">
      <div onClick={() => setActiveFilters([])} styleName="text-wrapper">
        <h1>#YOU</h1>
        <h1 styleName="padding-left">TOO?</h1>
      </div>
    </div>
  );
}
